export default "__VITE_ASSET__DBO0yd79__"